import { types } from 'mobx-state-tree';

import joinLine from './join-line';
import racePk from './race-pk';
import heartbeatPk from './heartbeat-pk';
import maskPk from './mask-pk';

const initState = {
  racePk: racePk.initState,
  joinLine: joinLine.initState,
  heartbeatPk: heartbeatPk.initState,
  maskPk: maskPk.initState,
};

const Model = types
  .model('LianmaiModel', {
    racePk: racePk.Model,
    joinLine: joinLine.Model,
    heartbeatPk: heartbeatPk.Model,
    maskPk: maskPk.Model,
  })
  .views((self) => {
    return {};
  })
  .actions((self) => {
    const init = () => {};

    return {
      init,
    };
  });

export default {
  initState,
  Model,
};
